module.exports = __webpack_public_path__ + "img/icon-phone.15fae311.svg";